import {memo} from 'react';
import {useWatch} from 'react-hook-form';

import {suffixTestId, TestIdProps} from 'shared/web';

import {VehicleModelSelect} from '../../ui/components/VehicleModelSelect';
import {useVehicleCreateMakeModel} from '../hooks/useVehicleCreateMakeModel';
import {useVehicleFormContext} from '../hooks/useVehicleFormContext';

export interface ModelSelectProps extends TestIdProps {}

export const ModelSelect = memo<ModelSelectProps>((props: ModelSelectProps = {}) => {
  const {control, vehicleType, baseTestId} = useVehicleFormContext();
  const {createCustomModel} = useVehicleCreateMakeModel();

  const vehicleMake = useWatch({
    control,
    name: 'formMake',
  });

  // Watch for unknown models to include them in options
  const unknownModels = useWatch({
    control,
    name: 'unknownModels',
  });

  return (
    <VehicleModelSelect
      isRequired
      vehicleType={vehicleType}
      vehicleMake={vehicleMake}
      control={control}
      unknownModels={unknownModels ?? []}
      onCreateOption={createCustomModel}
      data-testid={
        props['data-testid'] ? suffixTestId('model-select', props) : `model-select-${baseTestId}`
      }
    />
  );
});

ModelSelect.displayName = 'ModelSelect';
